import { Button, Card, CardBody, CardText, FormGroup, Input } from 'reactstrap';
import React from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
//import './createCharger.css';
import { verifyOTP, resendOTP } from '../../../utils/queries/profileQueries';
import { toast } from 'react-toastify';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  modal: {
    '& .modal-content': {
      width: '500px',
    },
    '& .modal-title': {
      fontSize: '17px',
    },
  },
  verifyButton: {
    // marginTop: '4px',
    height: '43px',
    backgroundColor: '#2675b8',
    marginLeft: '15px',
    width: '20%',
    color: 'white',
    border: 'none',
    fontWeight: 'normal',
    '&:hover': {
      backgroundColor: '#2675b8!important',
      color: 'white!important',
    },
    '&:focus': {
      backgroundColor: '#2675b8!important',
      color: 'white!important',
    },
    borderRadius: '5px',
  },
});

export default function VerifyOTPEmbedded({
  toggleVerifyOTPModalOpen,
  verifyOTPModalOpen,
  verificationAttribute,
  verificationAttributeValue,
}) {
  const classes = useStyles();
  const queryQlient = useQueryClient();
  const { mutateAsync: otpVerification } = useMutation(verifyOTP);
  const { mutateAsync: otpResend, isLoading: resendingOTP } =
    useMutation(resendOTP);
  const [otp, setOtp] = useState(null);
  const [verifyingOTP, setVerifyingOTP] = useState(false);

  async function verifyOtp() {
    try {
      if (!otp) {
        return toast.dark('OTP is empty.', {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      setVerifyingOTP(true);
      const otpVerificationObj = {
        otp,
        verificationAttribute,
      };
      await otpVerification(otpVerificationObj);
      await queryQlient.fetchQuery('customer/whoAmI');
      setOtp(null);
      toast.dark('OTP successfully verified', {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      toggleVerifyOTPModalOpen();
    } catch (error) {
      toast.dark(error.message, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setVerifyingOTP(false);
  }

  /**
   * ResendOTP for verification
   */
  async function resendOtp() {
    try {
      const resendOTPRequest = {
        attributeType: verificationAttribute,
      };
      await otpResend(resendOTPRequest);
      toast.success('OTP sent successfully', {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      toast.dark(error.message, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  return (
    <>
      <Card>
        <CardBody>
          <CardText>
            <div className="form-group">
              <div className="row">
                <div className="col-12 ">
                  {verificationAttribute === 'phone_number'
                    ? `Your current phone number is ${verificationAttributeValue}. We've sent an OTP to this phone number for security purpose.Please enter the OTP`
                    : `We've sent an OTP to ${verificationAttributeValue} for security purpose. Please enter the OTP to verify.`}
                </div>
                <div className="col-12 mt-3">
                  <FormGroup>
                    {/* <label className="form-control-label" htmlFor="input-city">
                      OTP
                    </label> */}
                    <Input
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      type="number"
                      placeholder="Enter OTP"
                    />
                  </FormGroup>
                </div>

                <div
                  className="col-12"
                  style={{
                    textAlign: 'center',
                  }}
                >
                  <Link
                    className={classes.resendOtp}
                    to="#"
                    onClick={resendOtp}
                  >
                    <small>
                      {resendingOTP ? 'Resending...' : 'Resend OTP'}
                    </small>
                  </Link>
                  <Button
                    color="primary"
                    className={classes.verifyButton}
                    onClick={verifyOtp}
                  >
                    {verifyingOTP ? 'Processing...' : 'Verify OTP'}
                  </Button>
                  <Link
                    className={classes.resendOtp}
                    style={{ marginLeft: 15 }}
                    to="#"
                    onClick={toggleVerifyOTPModalOpen}
                  >
                    <small>Cancel</small>
                  </Link>
                </div>
                {/* <div
                  className="col-12"
                  style={{
                    textAlign: 'center',
                    marginTop: '15px',
                  }}
                >
                  <Link
                    className={classes.resendOtp}
                    to="#"
                    onClick={resendOtp}
                  >
                    <small>
                      {resendingOTP ? 'Resending...' : 'Resend OTP'}
                    </small>
                  </Link>
                </div> */}
              </div>
            </div>
          </CardText>
        </CardBody>
      </Card>

      {/* <Modal
        isOpen={verifyOTPModalOpen}
        toggle={toggleVerifyOTPModalOpen}
        className={classes.modal}
        backdrop={'static'}
        fade={true}
      >
        <ModalHeader
        toggle={toggleVerifyOTPModalOpen}
        style={{ marginTop: '10px' }}
        closeButton={false}
        className={classes.modalHeader}
      >
        Verify{' '}
        {verificationAttribute === 'phone_number' ? 'Phone Number' : 'Email'}
        </ModalHeader>
        <ModalBody style={{ marginTop: '-30px' }}>
         
        </ModalBody>
      </Modal> */}
    </>
  );
}
